<template>
  <div class="mobile-app">
    <div class="head">
      <img class="logo" src="/ytpte.png" alt="" />
      <div class="menu-list">
        <div class="menu-item" @click="openWeChat">全题型练习111</div>
        <div class="menu-item" @click="openWeChat">学习数据</div>
        <div class="menu-item" @click="openWeChat">学习工具</div>
        <div class="menu-item" @click="openWeChat">VIP</div>
        <div class="menu-item active">课程资料</div>
      </div>
    </div>
    <div class="banner">
      <div class="swiper-container">
        <swiper :slides-per-view="1" :space-between="20" :pagination="{ clickable: true }">
          <swiper-slide v-for="slide in slides" :key="slide.id">
            <img @click="openWeChat" :src="slide.image" alt="" class="swiper-image" />
          </swiper-slide>
        </swiper>
      </div>
      <img @click="openWeChat" style="width: 100%" src="@/assets/images/config/img-b.png" alt="" />
    </div>
    <div class="path-box">
      <div class="path-box-item">
        <img class="path-img" src="@/assets/m/aa.png" alt="" />
        <div class="path-info">
          <div class="path-info-item">
            <span
              ><img
                class="item-icon"
                src="@/baidupteAssets/icon/jccs.png"
                alt=""
              />测试你的PTE基础水平 总时长18min</span
            >
            <el-button @click="openWeChat" class="btn" type="danger" round>
              去测试<img class="button-img" src="@/baidupteAssets/icon/jinru.png" alt="" />
            </el-button>
          </div>
          <div class="path-info-item">
            <span
              ><img
                class="item-icon"
                src="@/baidupteAssets/icon/nlfx.png"
                alt=""
              />羊驼老师在线指导，诊断分析你备考中存在的问题</span
            >
            <el-button @click="openWeChat" class="btn" type="primary" round>
              去咨询<img class="button-img" src="@/baidupteAssets/icon/jinru.png" alt="" />
            </el-button>
          </div>
        </div>
      </div>
      <div class="path-box-item">
        <img class="path-img" src="@/assets/m/aa.png" alt="" />
        <div class="path-info">
          <div class="path-info-item">
            <span
              ><img
                class="item-icon"
                src="@/baidupteAssets/icon/dzjh.png"
                alt=""
              />根据你的考试目标分数，推荐适合的学习备考计划</span
            >
            <el-button @click="openWeChat" class="btn" type="danger" round>
              去领取<img class="button-img" src="@/baidupteAssets/icon/jinru.png" alt="" />
            </el-button>
          </div>
          <div class="path-info-item">
            <span
              ><img class="item-icon" src="@/baidupteAssets/icon/jyjl.png" alt="" />每日预测、
              RA打卡群,考过的学员一起分享考试遇到的题目，及时掌握考试动态</span
            >
            <el-button @click="openWeChat" class="btn" type="primary" round>
              加入群聊<img class="button-img" src="@/baidupteAssets/icon/jinru.png" alt="" />
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="bk-material">
      <div class="label">免费备考资料</div>
      <div class="file-list">
        <div class="file-item" v-for="item in documents">
          <img class="file-icon" :src="fileIconUrl(item)" alt="" />
          <div class="file-name">{{ item.title }}</div>
          <el-button class="get-file" type="primary" plain round @click="openWeChat"
            >获取</el-button
          >
        </div>
      </div>
      <div class="group">
        <div class="group-item">
          <div class="group-title">
            <span>押题预测群</span>
            <div class="join-btn" @click="openWeChat">加入预测群</div>
          </div>
          <img class="group-img" src="@/assets/m/ytysq@2x.png" alt="" />
        </div>
        <div class="group-item">
          <div class="group-title">
            <span>押题预测群</span>
            <div @click="openWeChat" class="join-btn">加入打卡群</div>
          </div>
          <img class="group-img" src="@/assets/m/radkq@2x.png" alt="" />
        </div>
      </div>
    </div>
    <div class="course">
      <div class="label">羊驼PTE品质课程</div>
      <div class="course-list">
        <div
          class="course-item"
          @click="toInfo(item.courseId)"
          v-for="item in courseList.filter((v) =>
            [170, 108, 171, 24, 359, 459].includes(v.courseId)
          )"
          :key="item.courseId"
        >
          <div class="item-left">
            <img class="course-icon" :src="item.coverImage" alt="" />
            <div class="course-des">{{ item.forPeople }}</div>
          </div>
          <div class="item-right">
            <div class="course-title">{{ item.courseName }}</div>
            <div class="course-tag-box" v-if="item.teacher">
              <span
                class="tag"
                :class="[tagIdx == 0 ? 'gold' : '']"
                v-for="(tag, tagIdx) in parsedData(item.teacher.tag)"
              >
                {{ tag }}</span
              >
            </div>
            <div class="icon"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="course-system">
      <div class="label">羊驼课程体系</div>
      <div class="switc-hover">
        <el-button
          @click="switcIndex = 0"
          class="btn"
          :type="switcIndex === 0 ? 'primary' : 'info'"
          round
          >融会贯通</el-button
        >
        <img class="sandian" src="@/assets/m/sandian@2x.png" alt="" />
        <el-button
          @click="switcIndex = 1"
          class="btn"
          :type="switcIndex === 1 ? 'primary' : 'info'"
          round
          >深化技能</el-button
        >
        <img class="sandian" src="@/assets/m/sandian@2x.png" alt="" />
        <el-button
          @click="switcIndex = 2"
          class="btn"
          :type="switcIndex === 2 ? 'primary' : 'info'"
          round
          >夯实基础</el-button
        >
      </div>
      <div class="course-label">
        <span style="color: var(--el-color-primary)">羊驼内部</span>备考策略
      </div>
      <div class="item item_a hide" v-show="switcIndex === 0">
        <div class="box_a">
          <div class="box_item box_a_item">
            <div class="label-bar">
              <img src="@/views/information/images/kqyb.png" alt="" />
              <div class="label">考前预备</div>
            </div>
            <p class="text">报考流程，考场攻略，考前疏导样样具备</p>
          </div>
          <div class="box_item box_a_item">
            <div class="label-bar">
              <img src="@/views/information/images/mkcs.png" alt="" />
              <div class="label">模考测试</div>
            </div>
            <p class="text">官方模拟考试，还原考场流程、考试界面</p>
          </div>
          <div class="box_item box_a_item">
            <div class="label-bar">
              <img src="@/views/information/images/kqpg.png" alt="" />
              <div class="label">考前评估</div>
            </div>
            <p class="text">从心态、答题结果、临场发挥给出综合性考试建议及冲刺建议</p>
          </div>
          <div class="box_item box_a_item">
            <div class="label-bar">
              <img src="@/views/information/images/ycgp.png" alt="" />
              <div class="label">预测高频</div>
            </div>
            <p class="text">重点题型全覆盖，短期拔高训练，刷的每一道题都为考试做足了准备</p>
          </div>
          <div class="box_item box_a_item">
            <div class="label-bar">
              <img src="@/views/information/images/yzsbk.png" alt="" />
              <div class="label">APP/WEB一站式备考</div>
            </div>
            <p class="text">OFFICIAL真题练习材料，为PTEER提供全科在线学习的智能教育平台</p>
          </div>
        </div>
        <div class="box_b">
          <div class="box_b_item">定向复习：微信打卡、阶段测、实时诊断弱项调整备考方向</div>
          <div class="box_b_item">
            督学辅导：专属答疑，3V1（小助手，教辅老师，名师配备），全程进度监督
          </div>
        </div>
        <div class="box_c">
          <div class="zx-but" @click="openWeChat"></div>
          <div class="sp-but" @click="openWeChat"></div>
        </div>
      </div>
      <div class="item item_b hide" v-show="switcIndex === 1">
        <div class="box_cc">
          <div class="box_item box_a">
            <div class="label-bar">
              <img src="@/views/information/images/xxjh.png" alt="" />
              <div class="label">学习计划</div>
            </div>
            <p class="text">个性化定制并动态调整阶段性复习量</p>
          </div>

          <div class="box_item">
            <div class="label-bar">
              <img src="@/views/information/images/xqfk.png" alt="" />
              <div class="label">学情反馈</div>
            </div>
            <p class="text">任课老师总结课堂内容，对同学的表现进行简要点评，随时调整教学进度</p>
          </div>
          <div class="box_item">
            <div class="label-bar">
              <img src="@/views/information/images/dxfd.png" alt="" />
              <div class="label">督学辅导</div>
            </div>
            <p class="text">专属答疑，3V1（羊驼小助手，教辅老师，名师配备），全程进度监督</p>
          </div>
        </div>
        <div class="dz-but" @click="openWeChat"></div>
      </div>

      <div class="item item_c hide" v-show="switcIndex === 2">
        <div class="box_item box_a_item">
          <img class="icon_img" src="@/views/information/images/mdzd.png" alt="摸底诊断" />
          <div class="context">
            <h5 class="lable">摸底诊断</h5>
            <p class="text">为保证课堂效果，30分钟全面测试学员基础，为后续正课内容铺垫。</p>
          </div>
        </div>
        <div class="box_item box_a_item">
          <img class="icon_img" src="@/views/information/images/ljpte.png" alt="了解PTE" />
          <div class="context">
            <h5 class="lable">了解PTE</h5>
            <p class="text">
              PTE题型概况、PTE所需基础发音&语法基石，摒弃庞大复杂的语法库，只给你刚刚好需要的语法。
            </p>
          </div>
        </div>
        <div class="box_c">
          <div class="rm-but" @click="openWeChat"></div>
          <div class="sp-but" @click="openWeChat"></div>
        </div>
      </div>
    </div>
    <div class="teacher">
      <div class="teacher-main">
        <div class="swiper-wrapper">
          <div class="teacher-item swiper-slide" v-for="(project, index) in teacherList">
            <div class="title-text-img">羊驼PTE教研团队</div>
            <div class="teacher-info" v-if="project.swiper[project.activeIndex]">
              <img class="teacher-img" :src="project.swiper[project.activeIndex].imageUrl" alt="" />
              <div class="teacher-text">
                <p class="p-1">
                  <span class="name">{{ project.swiper[project.activeIndex].username }}</span>
                  <span class="tag tag-1">学员众多</span>
                  <span class="tag tag-2">多年经验</span>
                </p>
                <p class="p-2" v-if="project.swiper[project.activeIndex].graduationSchool">
                  {{ project.swiper[project.activeIndex].graduationSchool }}
                </p>
                <p class="p-3">
                  {{ project.swiper[project.activeIndex].describe }}
                </p>
              </div>
            </div>
            <div class="teacher-min-swiper" ref="teacherMinSwiper">
              <ul class="teacher-min swiper-wrapper">
                <li
                  @click="swiperSlideClick(index, idx)"
                  :class="{ hid: idx === project.activeIndex }"
                  class="teacher-min-item swiper-slide"
                  v-for="(item, idx) in project.swiper"
                >
                  <img :src="item.imageUrl" alt="" />
                  <div class="text-mask">
                    <p class="name">{{ item.username }}</p>
                    <p class="school" v-if="item.graduationSchool">
                      {{ item.graduationSchool }}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="label">
              <span>优秀授课老师</span>
            </div>
            <div class="min-list">
              <div class="min-item" v-for="item in project.list">
                <img class="icon" :src="item.icon" alt="" />
                <span class="name">{{ item.username }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="honor">
      <div class="label">荣誉资质</div>
      <div class="honor-swiper" ref="honorSwiper1">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/top-1.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/top-2.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/top-3.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/top-4.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/top-5.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/center-1.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/center-2.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/center-3.png" alt="" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="honor-swiper" ref="honorSwiper2">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/bottom-1.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/bottom-2.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/bottom-3.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/bottom-4.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/bottom-5.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/center-4.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/center-5.png" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="https://www.yangtuoedu.com/static/alpacaImages/m/center-6.png" alt="" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="corporate">
      <div class="label">公司环境</div>
      <div class="img-main">
        <div class="img-box">
          <div class="top">
            <img
              style="width: 37.47vw"
              src="https://www.yangtuoedu.com/static/alpacaImages/m/gs-1.png"
              alt=""
            />
            <div class="img-box">
              <img src="https://www.yangtuoedu.com/static/alpacaImages/m/gs-2.png" alt="" />
              <img src="https://www.yangtuoedu.com/static/alpacaImages/m/gs-3.png" alt="" />
            </div>
          </div>
          <img src="https://www.yangtuoedu.com/static/alpacaImages/m/gs-4.png" alt="" />
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="top">
        <a href="#" @click="openWeChat">联系我们</a>
        <a href="#" @click="openWeChat">客服咨询</a>
        <a
          href="https://www.yangtuoedu.com/static/appPage/license/index.html?type=1"
          target="_blank"
          rel="noopener noreferrer"
          >证照信息</a
        >
      </div>
      <div class="intro">
        <div class="title">公司简介</div>
        <div class="text">
          湖南羊驼教育科技有限公司成立于2017年，由刘雅丽创办，羊驼教育是国
          内最早一批做PTE教培的公司，在PTE考培市场的占有率排名第一，自
          2017年成立至今，羊驼教育已经由王牌的PTE，发展到雅思、韩语、日语、
          英语等多个业务线的教育培训机构。
        </div>
        <img class="service-pearson-logo" src="@/assets/m/peisheng@2x.png" alt="" />
        <div style="margin-top: 4vw" class="title">公司地址</div>
        <div class="text">湖南省长沙市岳麓区，中电软件园二期C3栋</div>
      </div>
      <div class="bottom">
        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          rel="noopener noreferrer"
        >
          ©湖南羊驼教育科技有限公司 | 备案号：湘ICP备18003463号-1
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" name="">
import { type Document, type PurchaseCourse } from '@/views/information/index.type'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'

import SwiperDom from 'swiper'
import 'swiper/css'
import { nextTick, onMounted, ref } from 'vue'
import bannerImg from '@/assets/m/banner.png'
const slides = ref([{ id: 1, image: bannerImg }])
import wjj from '@/views/information/images/wjj.png'
import xlsx from '@/views/information/images/xlsx.png'
import pdf from '@/views/information/images/pdf.png'
import doc from '@/views/information/images/doc.png'
import { http } from '@/utils'

const search = new URLSearchParams(window.location.search)
const query = ref<any>({ bd_vid: search.get('bd_vid') })
const documents = ref<Document[]>([])
const getInformationList = () => {
  http
    .get<Document[]>('/api/miniprogram/information/categoryList', { categoryId: 1 })
    .then((res) => {
      documents.value = res.data.filter((item, index) => {
        if (index <= 10) {
          return item
        }
      })
    })
}
const fileIconUrl = (item: Document) => {
  if (item.downloadLink) {
    const ext = getFileExtensionFromUrl(item.downloadLink)
    switch (ext) {
      case 'pdf':
        return pdf
      case 'doc':
        return doc
      case 'docx':
        return doc
      case 'xls':
        return xlsx
      case 'xlsx':
        return xlsx
      default:
        return wjj
    }
  }
  return wjj
}
const courseList = ref<PurchaseCourse[]>([])

const getCourse = () => {
  http.get('/api/curriculum/getOtherCourseList').then((res) => {
    courseList.value = res.data.purchaseCourseList
  })
}
const parsedData = (des: string) => {
  return des.split('&&&').map((item) => item.trim())
}

const switcIndex = ref(0)

const teacherList = ref<any>({
  1: { swiper: [], list: [], activeIndex: 0 } //PTE
})

const teacherMinSwiper = ref<HTMLDivElement[]>([])
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let teacherSwiper1: SwiperDom | null = null
const getTeacherList = () => {
  http.get('https://kt.ytaxx.com/api/teacher/queryHomeTeacher').then((res) => {
    const list = res.data
    list.forEach((item: { type: string | number; imageUrl: any }) => {
      if (teacherList.value[item.type] && item.type === 1) {
        if (item.imageUrl) {
          teacherList.value[item.type].swiper.push(item)
        } else if (teacherList.value[item.type].list.length < 20) {
          teacherList.value[item.type].list.push(item)
        }
      }
    })
    teacherSwiper1 = new SwiperDom(teacherMinSwiper.value[0], {
      slidesPerView: 'auto',
      grabCursor: true,
      freeMode: true
    })
  })
}
const swiperSlideClick = (index: number, idx: number) => {
  teacherList.value[index].activeIndex = idx
}

const honorSwiper1 = ref<HTMLDivElement>()
const honorSwiper2 = ref<HTMLDivElement>()
const inithonorSwiper = () => {
  nextTick(() => {
    if (honorSwiper1.value) {
      new SwiperDom(honorSwiper1.value, {
        slidesPerView: 'auto',
        modules: [Autoplay],
        slidesPerGroupAuto: true,
        spaceBetween: 10,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000 //1.5秒切换一次
        }
      })
    }
    if (honorSwiper2.value) {
      new SwiperDom(honorSwiper2.value, {
        slidesPerView: 'auto',
        slidesPerGroupAuto: true,
        spaceBetween: 10,
        modules: [Autoplay],
        autoplay: {
          disableOnInteraction: false,
          reverseDirection: true
        }
      })
    }
  })
}
const toInfo = (id: number) => {
  window.location.href = `/baidupte/material/purchaseH5/index.html?id=${id}&bd_vid=${query.value.bd_vid}`
}
const openWeChat = () => {
  window.location.href = `https://work.weixin.qq.com/ca/cawcde53cfad2cc7d3?customer_channel=0*3227*${query.value.bd_vid}`
}
onMounted(() => {
  getInformationList()
  getCourse()
  getTeacherList()
  inithonorSwiper()
})

function getFileExtensionFromUrl(url: string) {
  // 使用正则表达式来匹配文件后缀名
  const match = url.match(/\.([^.]+)(?:\?|$)/)
  if (match && match[1]) {
    // 返回匹配到的后缀名
    return match[1].toLowerCase()
  }
  // 如果没有匹配到后缀名，则返回空字符串
  return ''
}
</script>

<style lang="scss" scoped>
.mobile-app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  .head {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    padding: 5.07vw 4vw;
    padding-bottom: 2.8vw;
    display: flex;
    flex-direction: column;
    gap: 2vw 0;
    .logo {
      width: 24.76vw;
      display: block;
    }
    .menu-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .menu-item {
        position: relative;
        font-size: 3.47vw;
        color: #87869a;
        &.active {
          font-weight: bold;
          color: #7568ff;
          &::after {
            content: '';
            position: absolute;
            bottom: -2.8vw;
            left: 50%;
            width: 75%;
            height: 0.53vw;
            background: #7568ff;
            transform: translateX(-50%);
          }
        }
      }
      .menu-item {
      }
      .active {
      }
    }
  }
  .banner {
    .swiper-container {
      width: 100%;
    }

    .swiper-image {
      width: 100%;
      object-fit: contain;
    }
  }
  .path-box {
    display: flex;
    flex-direction: column;
    gap: 3.8vw 0;
    padding: 6.4vw 4vw;
    .path-box-item {
      display: flex;
      flex-direction: column;
      gap: 1.33vw 0;
      .path-img {
        display: block;
      }
      .path-info {
        display: flex;
        justify-content: space-between;
        .path-info-item {
          position: relative;
          box-sizing: border-box;
          padding: 0 3.6vw;
          padding-top: 8vw;
          width: 44.67vw;
          height: 30.13vw;
          font-size: 3vw;
          background: url(@/assets/m/hong@2x.png);
          background-size: cover;
          color: var(--el-color-danger);
          line-height: 4.13vw;
          &:nth-child(2) {
            background: url(@/assets/m/lan@2x.png);
            background-size: cover;
            color: var(--el-color-primary);
          }
          .item-icon {
            width: 3.78vw;
            height: 3.78vw;
            vertical-align: sub;
            margin-right: 0.4vw;
          }
          .btn {
            position: absolute;
            bottom: 2.6vw;
            right: 2.6vw;
            height: 4.8vw;
            line-height: 4.8vw;
            padding: 0 1.7vw;
            display: flex;
            align-items: center;
            font-size: 2.93vw;
            .button-img {
              width: 1.2vw;
              margin-left: 0.4vw;
            }
          }
        }
      }
    }
  }
  .bk-material {
    background-image: url(@/assets/m/bja@2x.png);
    padding: 0 4vw;
    padding-top: 6.4vw;
    padding-bottom: 5.2vw;
    .label {
      font-weight: 800;
      font-size: 4.27vw;
      color: #000000;
    }
    .file-list {
      margin-top: 3.2vw;
      background: #ffffff;
      box-shadow: 0vw 0vw 1.33vw 0.13vw rgba(0, 0, 0, 0.1);
      border-radius: 4vw 4vw 4vw 4vw;
      padding: 0 4vw;
      .file-item {
        padding: 4vw 0;
        display: flex;
        align-items: center;
        border-bottom: 0.13vw solid #f5f5f5;
        &:last-child {
          border-bottom: none;
        }
        .file-icon {
          width: 4.02vw;
          height: 4.83vw;
          margin-right: 1.6vw;
        }
        .file-name {
          flex: 1;
          font-size: 2.93vw;
        }
        .get-file {
          width: 12.53vw;
          height: 5.33vw;
          font-size: 2.93vw;
        }
      }
    }
    .group {
      position: relative;
      height: 44.13vw;
      background: #ffffff;
      border-radius: 4vw;
      margin-top: 4.67vw;
      display: flex;
      align-items: flex-start;
      padding: 3.2vw 3.4vw;
      gap: 0 2.53vw;
      .group-item {
        flex: 1;
        .group-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-weight: bold;
          font-size: 3.47vw;
          color: #000000;
          .join-btn {
            height: 4.39vw;
            background: linear-gradient(180deg, #9568ff 0%, #7c76ff 100%);
            border-radius: 2.67vw;
            font-size: 2.67vw;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 1.2vw;
            font-weight: 400;
          }
        }
        .group-img {
          width: 100%;
          margin-top: 2vw;
        }
      }
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%) translateY(-100%);
        width: 4.67vw;
        height: 2.27vw;
        background-image: url(@/assets/m/top-icon.png);
        background-size: cover;
      }
    }
  }
  .course {
    padding: 6.4vw 4vw;
    .label {
      font-weight: 800;
      font-size: 4.27vw;
      color: #000000;
    }
    .course-list {
      margin-top: 3.2vw;
      display: flex;
      flex-direction: column;
      gap: 3.47vw 0;
      .course-item {
        background-color: #ffffff;
        box-shadow: 0vw 0vw 1.07vw 0.13vw rgba(0, 0, 0, 0.07);
        border-radius: 4vw;
        padding: 4vw;
        padding-bottom: 2.67vw;
        box-sizing: border-box;
        display: flex;
        align-items: stretch;
        overflow: hidden;
        text-align: left;
        cursor: pointer;

        .item-left {
          width: 32.67vw;
          font-weight: 400;
          font-size: 3.07vw;
          color: var(--el-text-color-secondary);
          height: 100%;
          overflow: hidden;
          .course-icon {
            height: 22.67vw;
            background: #ffffff;
            border-radius: 2vw 2vw 0vw 0vw;
            opacity: 0.94;
            border-radius: 2.67vw;
            object-fit: cover;
          }
          .course-des {
            margin-top: 1.2vw;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .item-right {
          flex: 1;
          margin-left: 3.3vw;
          overflow: hidden;
          display: flex;
          flex-direction: column;

          .course-title {
            font-weight: 800;
            font-size: 3.73vw;
            color: var(--el-text-color-primary);
          }

          .course-tag-box {
            flex: 1;
            font-weight: 400;
            font-size: 2.8vw;
            color: var(--el-text-color-secondary);
            line-height: 3.4vw;
            margin-top: 2vw;
            overflow: hidden;

            .tag {
              margin-right: 1.2vw;
              &::after {
                display: inline-block;
                content: '';
                height: 1.58vw;
                width: 0.2vw;
                background-color: var(--el-text-color-secondary);
                margin-left: 1vw;
                margin-bottom: 0.1vw;
              }

              &.gold {
                color: #cb751e;
              }

              &:last-child {
                &::after {
                  display: none;
                }
              }
            }
          }

          .icon {
            margin-top: auto;
            margin-left: auto;
            width: 4.27vw;
            height: 4.27vw;
            background: url('@/assets/images/icon/jinru (1).png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .course-system {
    background-image: url(../assets/m/bjdd@2x.png);
    background-size: 100% auto;
    padding: 6.4vw 4vw;
    .label {
      font-weight: 800;
      font-size: 4.27vw;
      color: #000000;
    }
    .switc-hover {
      display: flex;
      align-items: center;
      gap: 0 1vw;
      margin-top: 3.2vw;
      .btn {
        width: 18.13vw;
        height: 5.6vw;
        border-radius: 3.33vw;
        font-size: 2.93vw;
        color: #ffffff;
      }
      .sandian {
        width: 3.6vw;
        height: 0.93vw;
        object-fit: cover;
      }
    }
    .course-label {
      margin-top: 4.13vw;
      position: relative;
      font-size: 3.73vw;
      line-height: 3.73vw;
      color: #000000;
      font-weight: 800;
      display: flex;
      align-items: center;
      margin-bottom: 2.53vw;
      &::before {
        content: '';
        display: block;
        width: 0.53vw;
        height: 3.6vw;
        border-radius: 0.4vw;
        background-color: var(--el-color-primary);
        margin-right: 1.07vw;
      }
    }
    .item {
      width: 100%;
      .box_item {
        background: #ffffff;
        box-shadow: 0px 0px 2vw 0.133333vw rgba(36, 34, 71, 0.04);
        border-radius: 2.4vw;
        padding: 2vw 3.066667vw;
        padding-right: 1.333333vw;
        box-sizing: border-box;
        overflow: hidden;

        .label-bar {
          display: flex;
          flex-direction: row;
          align-items: center;
          img {
            width: 3.14vw;
            height: 3.05vw;
          }
          .label {
            margin-left: 0.666667vw;
            font-weight: 800;
            font-size: 2.93vw;
            color: var(--el-color-primary);
          }
        }

        .text {
          font-weight: 400;
          font-size: 2.93vw;
          color: #2f2e51;
          margin-top: 0.4vw;
        }
      }
    }

    .item_a {
      display: flex;
      flex-direction: column;

      .box_a {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 3.2vw;
        row-gap: 2.666667vw;
        // grid-auto-rows: 12.533333vw;
      }

      .box_b {
        margin-top: 3.2vw;
        font-weight: 400;
        font-size: 2.93vw;
        color: #2f2e51;

        .box_b_item {
          display: flex;
          align-items: flex-start;
          gap: 0 1vw;
          &::before {
            margin-top: 1.2vw;
            content: '';
            display: inline-block;
            width: 1.866667vw;
            height: 2.266667vw;
            background-image: url('@/views/information/images/sanjiao.png');
            background-repeat: no-repeat;
            background-size: 100%;
            vertical-align: sub;
          }

          &:last-child {
            margin-top: 1.333333vw;
          }
        }
      }

      .box_c {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 3.733333vw;

        .zx-but {
          width: 32vw;
          height: 10.266667vw;
          background: url('@/views/information/images/kczx-a.png') no-repeat;
          background-size: 100%;
          cursor: pointer;
        }

        .sp-but {
          width: 32vw;
          height: 10.266667vw;
          background: url('@/views/information/images/spzdk.png') no-repeat;
          background-size: 100%;
          cursor: pointer;
        }
      }
    }
    .item_b {
      .box_cc {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 3.2vw;
        row-gap: 2.666667vw;

        .box_a {
          grid-column-start: 1;
          grid-column-end: 3;
          position: relative;

          &::before {
            content: '';
            display: block;
            position: absolute;
            background: url('@/views/information/images/bj.png');
            width: 31.466667vw;
            height: 100%;
            background-size: 100%;
            right: 0;
            top: 0;
          }
        }
      }

      .dz-but {
        width: 32vw;
        height: 10.266667vw;
        background: url('@/views/information/images/dzxxjh.png') no-repeat;
        background-size: 100%;
        margin-top: 7.2vw;
        margin-left: auto;
        cursor: pointer;
      }
    }

    .item_c {
      .box_a_item {
        width: 90.666667vw;
        border-radius: 3.333333vw;
        display: flex;
        align-items: center;
        padding: 4.8vw 6.133333vw;
        margin-bottom: 3.2vw;

        .icon_img {
          width: 16.4vw;
          height: auto;
        }

        .context {
          margin-left: 4.4vw;

          .lable {
            font-weight: 800;
            font-size: 2.933333vw;
            color: var(--el-color-primary);
          }

          .text {
            font-weight: 400;
            font-size: 2.93vw;
            color: #2f2e51;
          }
        }
      }

      .box_c {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 4.666667vw;

        .rm-but {
          width: 32vw;
          height: 10.266667vw;
          background: url('@/views/information/images/xbrmk.png') no-repeat;
          background-size: 100%;
          cursor: pointer;
        }

        .sp-but {
          width: 32vw;
          height: 10.266667vw;
          background: url('@/views/information/images/spzdk.png') no-repeat;
          background-size: 100%;
          cursor: pointer;
        }
      }
    }
  }
  .teacher {
    position: relative;
    padding: 6.4vw 4vw;
    background-color: #fff;

    .teacher-main {
      overflow: hidden;

      .teacher-item.swiper-slide-active {
        .min-list {
          .last,
          .next {
            display: block;
          }
        }
      }

      .title-text-img {
        font-weight: 800;
        font-size: 4.27vw;
        color: #000000;
      }

      .teacher-info {
        display: flex;
        margin-top: 3.2vw;
        .teacher-img {
          width: 29.73vw;
          height: 41.87vw;
          border-radius: 2.67vw;
          border: 0.13vw solid #e8e8e9;
          object-fit: cover;
        }

        .teacher-text {
          padding-left: 3.2vw;
          padding-top: 2.4vw;
          flex: 1;

          .p-1 {
            display: flex;
            align-items: center;
            gap: 0 1.87vw;
            font-size: 3.73vw;
            font-weight: bold;

            .tag {
              font-size: 2.13vw;
              padding: 0.53vw 0.8vw;
              border-radius: 1.07vw;

              &.tag-1 {
                background-color: #ffdfe7;
                color: #ff678b;
              }

              &.tag-2 {
                background-color: #ffe1c9;
                color: #ff9a4d;
              }
            }
          }

          .p-2 {
            font-size: 2.93vw;
            color: #000000;
            padding-top: 2.27vw;
          }

          .p-3 {
            margin-top: 1.87vw;
            color: #777a7e;
            font-size: 2.93vw;
            line-height: 4vw;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 6;
            -webkit-box-orient: vertical;
          }
        }
      }

      .teacher-min-swiper {
        margin-top: 3.87vw;
        margin-bottom: 5.4vw;
        overflow: hidden;

        .teacher-min {
          padding: 10px 10px;

          .teacher-min-item {
            position: relative;
            width: 25.84vw;
            height: 35.24vw;
            border-radius: 2.13vw;
            overflow: hidden;
            margin-right: 4vw;
            box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.07);

            &.hid {
              display: none;
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .text-mask {
              position: absolute;
              bottom: -1px;
              width: 100%;
              height: 18.06vw;
              background-image: url(https://www.yangtuoedu.com/static/alpacaImages/m/mask.png);
              background-size: 100% 100%;
              box-sizing: border-box;
              padding: 1.87vw 1.47vw;
              padding-top: 3vw;
              transform: translate(0, 2px);

              .name {
                font-weight: bold;
                color: #323232;
                font-size: 3.2vw;
              }

              .school {
                font-size: 2.67vw;
                color: #ef8150;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                /* 限制行数为3 */
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }
          }
        }
      }

      .label {
        display: inline-flex;
        position: relative;
        font-size: 3.73vw;
        color: #000000;
        font-weight: 800;

        span {
          position: relative;
          z-index: 10;
        }

        &::after {
          content: '';
          position: absolute;
          bottom: -0.9vw;
          left: 0vw;
          width: 5vw;
          height: 4vw;
          background: #ffd9b2;
          transform: skewX(-15deg) rotate(-15deg);
        }
      }

      .min-list {
        position: relative;
        margin-top: 3.3vw;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 3.2vw 0;

        .last {
          position: absolute;
          top: 12vw;
          left: 0;
          width: 11.87vw;
          height: 8.27vw;
          background-image: url(https://www.yangtuoedu.com/static/alpacaImages/m/syg@2x.png);
          z-index: 99;
          background-size: cover;
          display: none;
        }

        .next {
          position: absolute;
          top: 12vw;
          right: 0;
          width: 11.87vw;
          height: 8.27vw;
          background-image: url(https://www.yangtuoedu.com/static/alpacaImages/m/xyg@2x.png);
          z-index: 99;
          background-size: cover;
          display: none;
        }

        .min-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 1.33vw 0;

          .icon {
            width: 11.47vw;
            height: 11.47vw;
            background: #ffffff;
            border-radius: 50%;
            overflow: hidden;
            object-fit: cover;
          }

          .name {
            font-size: 2.67vw;
            color: #000000;
          }
        }
      }
    }
  }
  .honor {
    .label {
      font-weight: 800;
      font-size: 4.27vw;
      color: #000000;
    }
    padding: 6.4vw 4vw;
    background-image: url(https://www.yangtuoedu.com/static/alpacaImages/m/ryzzbj@2x.png);
    background-size: cover;
    .honor-swiper {
      overflow: hidden;
      margin-top: 3.2vw;
      .swiper-wrapper {
        .swiper-slide {
          width: 40vw;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  .corporate {
    .label {
      font-weight: 800;
      font-size: 4.27vw;
      color: #000000;
    }
    padding: 6.4vw 4vw;
    .img-main {
      margin-top: 4vw;
      .img-box {
        display: flex;
        flex-direction: column;
        gap: 2.67vw 0;
      }
      .top {
        display: flex;
        gap: 0 2.67vw;

        .img-box {
          width: 51.87vw;
        }
      }
    }
  }
  .footer {
    background-color: #333333;
    padding: 0 4vw;
    padding-top: 16vw;
    padding-bottom: 4.53vw;
    .top {
      display: flex;
      align-items: center;
      gap: 0 7vw;
      border-bottom: 0.13vw solid #575757;
      padding-bottom: 4.53vw;
    }
    .intro {
      padding: 4.53vw 0;
      border-bottom: 0.13vw solid #575757;
      .title {
        font-size: 2.67vw;
        color: #b8b8b8;
      }
      .text {
        font-size: 2.67vw;
        color: #e5e5e5;
        margin-top: 2.13vw;
      }
      .service-pearson-logo {
        width: 32.53vw;
        margin-top: 2.4vw;
      }
    }
    .bottom {
      padding-top: 4.5vw;
      a {
        display: flex;
        justify-content: center;
        color: #e5e5e5;
        font-size: 2.67vw;
      }
      div {
        margin-top: 2.4vw;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #e5e5e5;
        font-size: 2.67vw;
        gap: 0 1vw;
      }
    }
  }
}
</style>
